export default __webpack_public_path__ + "static/media/wineGlass.7c537f0c.jpg";